export default {"src":"/_next/static/media/compliance-updates.0ecab0fe.svg","height":946,"width":730,"blurWidth":0,"blurHeight":0};